export const formatEventDate = (value: string): string => {
  const isoDate = value.slice(0, 10);
  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) {
    return '';
  }
  return `${day}/${month}/${year}`;
};

export const stripEventDateFromBody = (body: string, eventDate?: string): string => {
  let nextBody = body.trim();
  if (eventDate) {
    nextBody = nextBody.replace(
      new RegExp(`(?:\\s+on\\s+${eventDate}|\\s*\\(${eventDate}\\)|,\\s*on\\s+${eventDate})\\.?$`, 'i'),
      ''
    );
  }
  nextBody = nextBody.replace(/\s+on\s+\d{4}-\d{2}-\d{2}\.?$/i, '');
  nextBody = nextBody.replace(/\s*\(\d{4}-\d{2}-\d{2}\)\.?$/i, '');
  return nextBody.trim().replace(/,$/, '');
};
